//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { Bank } from '../../graphql/entities';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';

const BANK_COLUMN_OVERRIDES = {
  'nominal.accountNo': {
    width: 150,
    name: 'Nominal Account',
  },
  'nominal.balance.balance': {
    name: 'Balance',
    formatter: Formatters.NumericFormatter,
    width: 150,
    options: {
      format: { decimals: 2 },
    },
  },
  'nominal.balance.baseBalance': {
    name: 'Balance GBP',
    formatter: Formatters.NumericFormatter,
    width: 150,
    options: {
      format: { decimals: 2 },
    },
  },
  reconciledBalance: {
    name: 'Reconciled Balance',
    formatter: Formatters.NumericFormatter,
    width: 150,
    options: {
      format: { decimals: 2 },
    },
  },
  accountBalance: {
    name: 'Account Balance',
    formatter: Formatters.NumericFormatter,
    width: 150,
    options: {
      format: { decimals: 2 },
    },
  },
  accountNo: {
    name: 'Bank Account No',
    width: 150,
  },
  'currency.isoCode.codeAlpha3': {
    name: 'Currency',
    width: 90,
  },
};

const BANK_FIELD_NAMES = [
  'description',
  'accountNo',
  'nominal.accountNo',
  'currency.isoCode.codeAlpha3',
  'nominal.balance.baseBalance',
  'reconciledBalance',
  'accountBalance',
];

const BankWorkspace = (props) => {
  const workspaceProps = useWorkspace(props, Bank, {
    columns: BANK_FIELD_NAMES,
    columnOverrides: BANK_COLUMN_OVERRIDES,
    initialSortColumn: 'description',
  });

  return (
    <Workspace
      entityType={Bank.type}
      title={Bank.title}
      formUrl={Bank.formUrl}
      defaultQuery={Bank.workspace}
      {...workspaceProps}
      {...props}
      entity={Bank}
    />
  );
};

export default BankWorkspace;
